var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"issue fill-height",attrs:{"id":"issue"}},[(_vm.imagePhotos || _vm.issue)?_c('div',[_c('issue-editor',{attrs:{"imagePhotoProp":_vm.imagePhotos,"issueProp":_vm.issue,"prevRoute":_vm.prevRoute}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }